/*
 * roo-stock.js — OMS-style "Inventory & cost" panel for STAFF users.
 *
 * The backend (/apps/roo/inventory) verifies STAFF status via HMAC-signed
 * logged_in_customer_id and returns:
 *   staff  -> { tier:"staff", stores:[{name,qoh,qoo,qoa,location,price}], dropship? }
 */
(function () {
  if (window.__rooStockLoaded) return;
  window.__rooStockLoaded = true;

  var INVENTORY_URL = "/apps/roo/inventory";

  function esc(s) {
    return String(s == null ? "" : s)
      .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;").replace(/'/g, "&#39;");
  }
  function fmtPrice(p) {
    if (p == null || isNaN(p)) return "—";
    return "$" + Number(p).toFixed(2);
  }
  function fmtSigned(p) {
    if (p == null || isNaN(p)) return "—";
    var n = Number(p);
    return (n >= 0 ? "+$" : "-$") + Math.abs(n).toFixed(2);
  }

  function init() {
    try {
      var root = document.getElementById("roo-stock-root");
      if (!root || root.dataset.rooInit === "1") return;
      root.dataset.rooInit = "1";

      var SKU = root.getAttribute("data-sku") || "";
      var UPC = root.getAttribute("data-upc") || "";
      var TITLE = root.getAttribute("data-title") || "";
      var PRICE = parseFloat(root.getAttribute("data-price") || "0");
      var leadDays = parseInt(root.getAttribute("data-pickup-lead-days"), 10);
      if (isNaN(leadDays)) leadDays = 5;

      var outputEl = root.querySelector("#roo-stock-output");
      if (!outputEl) return;

      var showAllStores = false;
      var lastData = null;

      function setStatus(msg, isError) {
        outputEl.innerHTML =
          '<div class="roo-stock-status' + (isError ? " error" : "") + '">' + esc(msg) + "</div>";
      }

      function renderStaff(data) {
        lastData = data;
        var allStores = (data && data.stores) || [];
        var eagleStores = [];
        var bciSynthRow = null;
        for (var i = 0; i < allStores.length; i++) {
          var st = allStores[i];
          if (st.name && st.name.indexOf("BCI") === 0) {
            bciSynthRow = st;
          } else {
            eagleStores.push(st);
          }
        }

        var totQoh = 0, totQc = 0, totQa = 0, totOo = 0;
        var activeStores = [];
        var hiddenCount = 0;
        var storePrice = (!isNaN(PRICE) && PRICE > 0) ? PRICE : null;

        for (var j = 0; j < eagleStores.length; j++) {
          var s = eagleStores[j];
          var qoh = s.qoh | 0;
          var qa = s.qoa | 0;
          var oo = s.qoo | 0;
          var qc = Math.max(0, qoh - qa);
          totQoh += qoh;
          totQc += qc;
          totQa += qa;
          totOo += oo;
          if (storePrice == null && s.price != null) storePrice = Number(s.price);
          if (qoh !== 0 || qa !== 0 || oo !== 0 || (s.location && s.location !== "—")) {
            activeStores.push({ name: s.name, bin: s.location || "—", qoh: qoh, qc: qc, qa: qa, oo: oo });
          } else {
            hiddenCount++;
          }
        }

        var rowsToRender = showAllStores
          ? eagleStores.map(function (s) {
              var qoh = s.qoh | 0;
              var qa = s.qoa | 0;
              var oo = s.qoo | 0;
              return { name: s.name, bin: s.location || "—", qoh: qoh, qc: Math.max(0, qoh - qa), qa: qa, oo: oo };
            })
          : (activeStores.length ? activeStores : eagleStores.map(function (s) {
              var qoh = s.qoh | 0;
              var qa = s.qoa | 0;
              var oo = s.qoo | 0;
              return { name: s.name, bin: s.location || "—", qoh: qoh, qc: Math.max(0, qoh - qa), qa: qa, oo: oo };
            }));

        // Build Buy-in rows (Orgill, BCI, ACE RSC E, True Value RDC 27)
        var dsSources = (data && data.dropship && data.dropship.sources) || [];
        function findSource(code) {
          for (var k = 0; k < dsSources.length; k++) {
            if (dsSources[k].code === code || dsSources[k].source === code) return dsSources[k];
          }
          return null;
        }
        var orgillSrc = findSource("ORGILL") || findSource("orgill");
        var bciSrc = findSource("BCI") || findSource("bci");
        var aceSrc = findSource("ACE_E") || findSource("ACE RSC E") || findSource("ace_e");
        var tvPaSrc = findSource("TV_PA") || findSource("TV PA") || findSource("tv_pa");

        var buyInRows = [
          { badge: "orgill", label: "ORGILL", src: orgillSrc },
          { badge: "bci", label: "BCI", src: bciSrc || (bciSynthRow ? { state: "qty", qa: bciSynthRow.qoa | 0, oo: 0, item: "—", cost: null } : null) },
          { badge: "ace", label: "ACE", src: aceSrc },
          { badge: "tv", label: "TV", src: tvPaSrc }
        ];

        var buyInAvail = 0;
        var cheapestCost = null;
        var cheapestName = null;
        for (var b = 0; b < buyInRows.length; b++) {
          var br = buyInRows[b].src;
          if (br && typeof br.qa === "number" && br.qa > 0) buyInAvail += br.qa;
          if (br && br.cost != null && !isNaN(br.cost) && Number(br.cost) > 0) {
            if (cheapestCost == null || Number(br.cost) < cheapestCost) {
              cheapestCost = Number(br.cost);
              cheapestName = buyInRows[b].label;
            }
          }
        }

        // Dropshipper rows (ACE OTH / TV DROPSHIP breakdowns)
        var dropRows = [];
        var dropAvail = 0;
        for (var d = 0; d < dsSources.length; d++) {
          var dsrc = dsSources[d];
          var dcode = String(dsrc.code || dsrc.source || "").toUpperCase();
          if (dcode.indexOf("OTH") > -1 || dcode.indexOf("DROPSHIP") > -1) {
            if (Array.isArray(dsrc.rdcs) && dsrc.rdcs.length) {
              for (var r = 0; r < dsrc.rdcs.length; r++) {
                var rdc = dsrc.rdcs[r];
                if ((rdc.qa | 0) > 0) {
                  dropAvail += (rdc.qa | 0);
                  dropRows.push({
                    badge: dcode.indexOf("TV") > -1 ? "tv" : "ace",
                    badgeText: dcode.indexOf("TV") > -1 ? "TV" : "ACE",
                    name: rdc.name || rdc.code || dsrc.name,
                    qa: rdc.qa | 0,
                    cost: rdc.cost != null ? rdc.cost : dsrc.cost
                  });
                }
              }
            } else if ((dsrc.qa | 0) > 0) {
              dropAvail += (dsrc.qa | 0);
              dropRows.push({
                badge: dcode.indexOf("TV") > -1 ? "tv" : "ace",
                badgeText: dcode.indexOf("TV") > -1 ? "TV" : "ACE",
                name: dsrc.name || dcode,
                qa: dsrc.qa | 0,
                cost: dsrc.cost
              });
            }
          }
        }

        var epicorLabel = (data && data.epicorSku) ? data.epicorSku : SKU;
        var nowStr = new Date().toLocaleString("en-US", { month: "long", day: "numeric", year: "numeric", hour: "numeric", minute: "2-digit" });

        var html = '<div class="roo-oms-panel">';
        html += '<div class="roo-oms-header">';
        html += '<h3 class="roo-oms-title">Inventory &amp; cost</h3>';
        if (TITLE) html += '<p class="roo-oms-subtitle">' + esc(TITLE) + '</p>';
        html += '<div class="roo-oms-id-row">';
        if (epicorLabel) html += '<span>Epicor ' + esc(epicorLabel) + '</span>';
        if (SKU && SKU !== epicorLabel) html += '<span>&middot; Catalog ' + esc(SKU) + '</span>';
        if (UPC) html += '<span>&middot; UPC ' + esc(UPC) + '</span>';
        html += '</div></div>';

        // KPI Row
        html += '<div class="roo-oms-kpis">';
        html += '<div class="roo-oms-kpi"><div class="roo-oms-kpi__label">Sold For (Storefront)</div><div class="roo-oms-kpi__val">' + esc(fmtPrice(storePrice)) + '</div><div class="roo-oms-kpi__sub">Hatchet Farm retail price</div></div>';
        html += '<div class="roo-oms-kpi"><div class="roo-oms-kpi__label">Our Cost (Best Buy-In)</div><div class="roo-oms-kpi__val">' + (cheapestCost != null ? esc(fmtPrice(cheapestCost)) : "—") + '</div><div class="roo-oms-kpi__sub ' + (cheapestCost != null && storePrice != null ? "roo-oms-kpi__sub--pos" : "") + '">' + (cheapestCost != null && storePrice != null ? esc(fmtSigned(storePrice - cheapestCost)) + " margin via " + esc(cheapestName) : "Distributor cost per unit") + '</div></div>';
        html += '<div class="roo-oms-kpi"><div class="roo-oms-kpi__label">Total Network Stock</div><div class="roo-oms-kpi__val">' + (totQa + buyInAvail) + ' avail</div><div class="roo-oms-kpi__sub">' + totQa + ' in Eagle stores &middot; ' + buyInAvail + ' at distributors</div></div>';
        html += '</div>';

        // 2-Column Grid
        html += '<div class="roo-oms-grid">';

        // Left Column: Our stock + Buy in to our store
        html += '<div>';
        html += '<div class="roo-oms-block">';
        html += '<div class="roo-oms-block__head"><div><h4 class="roo-oms-block__title">Our stock</h4><p class="roo-oms-block__desc">Eagle stores</p></div><div class="roo-oms-block__count"><strong>' + totQa + '</strong><span>available</span></div></div>';
        html += '<table class="roo-oms-table"><thead><tr><th>Warehouse</th><th>Bin</th><th class="num">QOH</th><th class="num">QC</th><th class="num">QA</th><th class="num">OO</th></tr></thead><tbody>';
        for (var m = 0; m < rowsToRender.length; m++) {
          var row = rowsToRender[m];
          html += '<tr><td>' + esc(row.name) + '</td><td class="bin">' + esc(row.bin) + '</td><td class="num">' + row.qoh + '</td><td class="num">' + row.qc + '</td><td class="num ' + (row.qa > 0 ? "qa-pos" : "") + '">' + row.qa + '</td><td class="num">' + row.oo + '</td></tr>';
        }
        html += '</tbody><tfoot><tr><td>Total (' + eagleStores.length + ' locations)</td><td></td><td class="num">' + totQoh + '</td><td class="num">' + totQc + '</td><td class="num">' + totQa + '</td><td class="num">' + totOo + '</td></tr></tfoot></table>';
        if (hiddenCount > 0 && activeStores.length > 0) {
          html += '<div class="roo-oms-toggle-row">' + (showAllStores ? 'Showing all ' + eagleStores.length + ' locations. <button type="button" class="roo-oms-toggle-btn" data-roo-toggle-stores>Hide 0-stock locations</button>' : hiddenCount + ' locations with no stock hidden. <button type="button" class="roo-oms-toggle-btn" data-roo-toggle-stores>Show all ' + eagleStores.length + '</button>') + '</div>';
        }
        html += '</div>';

        // Buy in to our store
        html += '<div class="roo-oms-block">';
        html += '<div class="roo-oms-block__head"><div><h4 class="roo-oms-block__title">Buy in to our store</h4><p class="roo-oms-block__desc">Ships to us, not to the customer &mdash; then we ship it</p></div><div class="roo-oms-block__count"><strong>' + buyInAvail + '</strong><span>available</span></div></div>';
        html += '<table class="roo-oms-table"><thead><tr><th>Source</th><th>Vendor SKU</th><th class="num">QA</th><th class="num">OO</th><th class="num">Cost Ea</th><th class="num">Margin</th></tr></thead><tbody>';
        for (var bi = 0; bi < buyInRows.length; bi++) {
          var bItem = buyInRows[bi];
          var bSrc = bItem.src;
          var vSku = (bSrc && bSrc.item) ? bSrc.item : "—";
          var qaTxt = "NIF";
          var qaPositive = false;
          if (bSrc) {
            if (typeof bSrc.qa === "number") {
              qaTxt = String(bSrc.qa);
              qaPositive = bSrc.qa > 0;
            } else if (bSrc.state === "no_qty") {
              qaTxt = "catalogued";
            } else if (bSrc.state === "unknown") {
              qaTxt = "unknown";
            }
          }
          var ooTxt = (bSrc && typeof bSrc.oo === "number") ? String(bSrc.oo) : "—";
          var costVal = (bSrc && bSrc.cost != null && !isNaN(bSrc.cost)) ? Number(bSrc.cost) : null;
          var marginVal = (costVal != null && storePrice != null) ? (storePrice - costVal) : null;
          html += '<tr><td><span class="roo-oms-badge-src roo-oms-badge-src--' + bItem.badge + '">' + esc(bItem.label) + '</span></td><td class="bin">' + esc(vSku) + '</td><td class="num ' + (qaPositive ? "qa-pos" : "") + '">' + esc(qaTxt) + '</td><td class="num">' + esc(ooTxt) + '</td><td class="num">' + (costVal != null ? esc(fmtPrice(costVal)) : "—") + '</td><td class="num ' + (marginVal != null && marginVal > 0 ? "qa-pos" : "") + '">' + (marginVal != null ? esc(fmtSigned(marginVal)) : "—") + '</td></tr>';
        }
        html += '</tbody></table>';
        html += '</div>';
        html += '</div>'; // end left col

        // Right Column: Dropshippers
        html += '<div>';
        html += '<div class="roo-oms-block">';
        html += '<div class="roo-oms-block__head"><div><h4 class="roo-oms-block__title">Dropshippers</h4><p class="roo-oms-block__desc">Direct-to-customer distributor warehouses</p></div><div class="roo-oms-block__count"><strong>' + dropAvail + '</strong><span>available</span></div></div>';
        html += '<table class="roo-oms-table"><thead><tr><th>Warehouse</th><th class="num">QA</th><th class="num">Cost Ea</th><th class="num">Before Ship</th></tr></thead><tbody>';
        if (dropRows.length > 0) {
          for (var dr = 0; dr < dropRows.length; dr++) {
            var dRow = dropRows[dr];
            var dCost = (dRow.cost != null && !isNaN(dRow.cost)) ? Number(dRow.cost) : null;
            var dMargin = (dCost != null && storePrice != null) ? (storePrice - dCost) : null;
            html += '<tr><td><span class="roo-oms-badge-src roo-oms-badge-src--' + dRow.badge + '" style="margin-right:6px;">' + esc(dRow.badgeText) + '</span>' + esc(dRow.name) + '</td><td class="num qa-pos">' + dRow.qa + '</td><td class="num">' + (dCost != null ? esc(fmtPrice(dCost)) : "—") + '</td><td class="num ' + (dMargin != null && dMargin > 0 ? "qa-pos" : "") + '">' + (dMargin != null ? esc(fmtSigned(dMargin)) : "—") + '</td></tr>';
          }
        } else {
          html += '<tr><td colspan="4" style="color:#6B7280;text-align:center;padding:1rem;">No direct-to-customer dropship stock reported for this item.</td></tr>';
        }
        html += '</tbody></table>';
        html += '</div>';
        html += '</div>'; // end right col

        html += '</div>'; // end grid
        html += '<div class="roo-oms-live-pill"><span class="roo-oms-live-dot"></span><span>Live &middot; as of ' + esc(nowStr) + '</span></div>';
        html += '</div>';

        outputEl.innerHTML = html;

        var toggleBtn = outputEl.querySelector("[data-roo-toggle-stores]");
        if (toggleBtn) {
          toggleBtn.addEventListener("click", function () {
            showAllStores = !showAllStores;
            renderStaff(lastData);
          });
        }
      }

      async function loadStock() {
        if (!SKU) {
          setStatus("No SKU available for this product.", true);
          return;
        }
        setStatus("Loading OMS inventory & cost…");
        var ctl = typeof AbortController !== "undefined" ? new AbortController() : null;
        var timer = ctl ? setTimeout(function () { ctl.abort(); }, 6000) : null;
        try {
          var res = await fetch(
            INVENTORY_URL + "?sku=" + encodeURIComponent(SKU),
            ctl ? { signal: ctl.signal } : {}
          );
          if (timer) clearTimeout(timer);
          if (!res.ok) throw new Error("HTTP " + res.status);
          var data = await res.json();
          renderStaff(data);
        } catch (e) {
          if (timer) clearTimeout(timer);
          if (window.console) console.warn("[roo-stock] fetch failed:", e && e.message);
          setStatus("Stock data temporarily unavailable.", true);
        }
      }

      loadStock();
    } catch (err) {
      if (window.console) console.warn("[roo-stock] init failed:", err && err.message);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
  document.addEventListener("shopify:section:load", init);
})();
